import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIUAFeatureTable from 'ui-addon-upgrades/featureTable/FeatureTable';
import FeatureTableColTag from '../../../components/feature-table/FeatureTableColTag';
import { SingleSkeletonLoader } from '../../components/SingleSkeletonLoader';
import { FeatureTableHeaderCellContent } from '../../components/feature-table/FeatureTableHeaderCellContent';
import { PinnedFeaturesConfig } from '../../constants/PinnedFeaturesConfig';
import { PriceByProductApiName } from '../../containers/PriceByProductApiName';
import { PurchaseMotionsByProductApiNameAndLocation } from '../../containers/PurchaseMotionsByProductApiNameAndLocation';
import { useBadges } from '../../hooks/badges/useBadges';
import { useFeaturesForApiNames } from '../../hooks/features/useFeatures';
import { pinKeyFeatures } from '../../utils/featureUtils';
import { createFeatureTableHeaderTrackingData } from '../../utils/trackingData';
import { isValidApiName } from '../../utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SmartCrmFeatureTable = () => {
  var _PinnedFeaturesConfig, _badges$coreSeatsPr, _badges$coreSeatsEn;
  const apiNames = ['core-seats-professional', 'core-seats-enterprise'].filter(isValidApiName);
  const {
    badges
  } = useBadges({
    productApiNames: apiNames
  });
  const {
    features,
    loading,
    error
  } = useFeaturesForApiNames(['core-seats-professional', 'core-seats-enterprise']);
  if (loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 250,
      width: "100%"
    });
  }
  if (error) {
    return null;
  }

  // Pin key features for Smart CRM
  const pinnedFeatures = features && features.length ? pinKeyFeatures(features, 'CORE_PLATFORM_SEATS', PinnedFeaturesConfig) : [];
  if (!pinnedFeatures || pinnedFeatures.length === 0) {
    return null;
  }

  // Build body data with Smart CRM features
  const bodyData = {
    sharedData: {
      subscreen: 'SMART_CRM',
      staticDisplayRowCount: (_PinnedFeaturesConfig = PinnedFeaturesConfig['CORE_PLATFORM_SEATS']) === null || _PinnedFeaturesConfig === void 0 ? void 0 : _PinnedFeaturesConfig.length
    },
    sectionData: {
      'smart-crm': {
        apiNames,
        features: pinnedFeatures,
        LabelContent: /*#__PURE__*/_jsx(_Fragment, {})
      }
    }
  };

  // Build header data for the two tiers
  const headerData = {
    ['core-seats-professional']: {
      Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
        Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
          apiName: 'core-seats-professional',
          badgeName: badges === null || badges === void 0 || (_badges$coreSeatsPr = badges['core-seats-professional']) === null || _badges$coreSeatsPr === void 0 ? void 0 : _badges$coreSeatsPr.badgeName
        }),
        ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "pricing-pages-ui.merchCardsV2.smartCrm.professionalCard.title"
        }),
        Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
          productApiName: 'core-seats-professional'
        }),
        PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
          productApiName: 'core-seats-professional',
          location: "MERCH_CARD",
          displayCount: 1,
          trackingData: createFeatureTableHeaderTrackingData('core-seats-professional', 'smart-crm')
        })
      })
    },
    ['core-seats-enterprise']: {
      Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
        Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
          apiName: 'core-seats-enterprise',
          badgeName: badges === null || badges === void 0 || (_badges$coreSeatsEn = badges['core-seats-enterprise']) === null || _badges$coreSeatsEn === void 0 ? void 0 : _badges$coreSeatsEn.badgeName
        }),
        ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "pricing-pages-ui.merchCardsV2.smartCrm.enterpriseCard.title"
        }),
        Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
          productApiName: 'core-seats-enterprise'
        }),
        PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
          productApiName: 'core-seats-enterprise',
          location: "MERCH_CARD",
          displayCount: 1,
          trackingData: createFeatureTableHeaderTrackingData('core-seats-enterprise', 'smart-crm')
        })
      })
    }
  };
  return /*#__PURE__*/_jsx(UIUAFeatureTable, {
    headerData: headerData,
    bodyData: bodyData,
    canViewNewSeats: true,
    isInbound25PricingPage: true
  });
};